// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ContentImage_wrapper__zsNFL","image":"ContentImage_image___kCIo"};